import { useEffect, useRef } from "react";

const TEN_MINUTES = 10 * 60 * 1000;

const useRunOnTabReturn = (callcack: () => void) => {
  const hiddenAtRef = useRef(null);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        hiddenAtRef.current = Date.now();
      }

      if (document.visibilityState === "visible") {
        if (hiddenAtRef.current) {
          const inactiveTime = Date.now() - hiddenAtRef.current;

          if (inactiveTime >= TEN_MINUTES) {
            callcack();
          }

          hiddenAtRef.current = null;
        }
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () =>
      document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, [callcack]);
};

export default useRunOnTabReturn;
